import {createAction, props} from '@ngrx/store';
import {LineChartDataModel} from '../../../../models/line-chart-data.model';
import {FetchHeightChartDataModel} from '../models/fetch-height-chart-data.model';
import {FetchHeightChartTableDataModel, HeightChartTableData} from '../models/fetch-height-chart-table-data.model';
import {FetchWeightChartDataModel} from '../models/fetch-weight-chart-data.model';
import {FetchWeightChartTableDataModel, WeightChartTableData} from '../models/fetch-weight-chart-table-data.model';
import {FetchDailyFoodChartDataModel} from '../models/fetch-daily-food-chart-data.model';
import {GroupedBarChartModel} from '../../../../models/grouped-bar-chart.model';
import {BarChartModel} from '../../../../models/bar-chart.model';
import {FetchWeeklyFoodChartDataModel} from '../models/fetch-weekly-food-chart-data.model';
import {FetchWeeklyFoodChartTableDataModel, WeeklyFoodChartTableData} from '../models/fetch-weekly-food-chart-table-data.model';
import {FetchBmiChartDataModel} from '../models/fetch-bmi-chart-data.model';
import {BmiChartTableData, FetchBmiChartTableDataModel} from '../models/fetch-bmi-chart-table-data.model';
import {Filter} from '../../../../models/filter';
import {FetchDailyPAChartDataModel} from "../models/fetch-daily-pa-chart-data.model";
import {FetchWeeklyPADataModel} from "../models/fetch-weekly-pa-data.model";
import {
  FetchPATableDataModel,
  PATableData
} from "../models/fetch-pa-table-data.model";
import {
  FetchDailySTChartDataModel
} from "../models/fetch-daily-st-chart-data.model";
import {FetchWeeklySTDataModel} from "../models/fetch-weekly-st-data.model";
import {
  FetchSTTableDataModel,
  STTableData
} from "../models/fetch-st-table-data.model";
import {FetchJournalChartTableDataModel, JournalChartTableData} from '../models/fetch-journal-chart-table-data.model';
import {FetchJournalChartDataModel, JournalChartDataModel} from '../models/fetch-journal-chart-data.model';


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[progress] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH HEIGHT CHART DATA ***********/
const FETCH_HEIGHT_CHART_DATA_REQUEST = '[progress] fetch height chart data requested';
export const FetchHeightChartDataRequest = createAction(FETCH_HEIGHT_CHART_DATA_REQUEST, props<{ payload?: FetchHeightChartDataModel['request'], forPrint?: boolean }>());

const FETCH_HEIGHT_CHART_DATA_SUCCESS = '[progress] fetch height chart data successful';
export const FetchHeightChartDataSuccess = createAction(FETCH_HEIGHT_CHART_DATA_SUCCESS, props<{
  data: LineChartDataModel,
  message: string
}>());

const FETCH_HEIGHT_CHART_DATA_FAILURE = '[progress] fetch height chart data failure';
export const FetchHeightChartDataFailure = createAction(FETCH_HEIGHT_CHART_DATA_FAILURE);

/******** FETCH HEIGHT CHART TABLE DATA ***********/
const FETCH_HEIGHT_CHART_TABLE_DATA_REQUEST = '[progress] fetch height chart table data requested';
export const FetchHeightChartTableDataRequest = createAction(FETCH_HEIGHT_CHART_TABLE_DATA_REQUEST, props<{ payload?: FetchHeightChartTableDataModel['request'], forPrint?: boolean }>());

const FETCH_HEIGHT_CHART_TABLE_DATA_SUCCESS = '[progress] fetch height chart table data successful';
export const FetchHeightChartTableDataSuccess = createAction(FETCH_HEIGHT_CHART_TABLE_DATA_SUCCESS, props<{
  data: HeightChartTableData,
  message: string
}>());

const FETCH_HEIGHT_CHART_TABLE_DATA_FAILURE = '[progress] fetch height chart table data failure';
export const FetchHeightChartTableDataFailure = createAction(FETCH_HEIGHT_CHART_TABLE_DATA_FAILURE);

/******** FETCH WEIGHT CHART DATA ***********/
const FETCH_WEIGHT_CHART_DATA_REQUEST = '[progress] fetch weight chart data requested';
export const FetchWeightChartDataRequest = createAction(FETCH_WEIGHT_CHART_DATA_REQUEST, props<{ payload?: FetchWeightChartDataModel['request'], forPrint?: boolean }>());

const FETCH_WEIGHT_CHART_DATA_SUCCESS = '[progress] fetch weight chart data successful';
export const FetchWeightChartDataSuccess = createAction(FETCH_WEIGHT_CHART_DATA_SUCCESS, props<{
  data: LineChartDataModel,
  message: string
}>());

const FETCH_WEIGHT_CHART_DATA_FAILURE = '[progress] fetch weight chart data failure';
export const FetchWeightChartDataFailure = createAction(FETCH_WEIGHT_CHART_DATA_FAILURE);

/******** FETCH WEIGHT CHART TABLE DATA ***********/
const FETCH_WEIGHT_CHART_TABLE_DATA_REQUEST = '[progress] fetch weight chart table data requested';
export const FetchWeightChartTableDataRequest = createAction(FETCH_WEIGHT_CHART_TABLE_DATA_REQUEST, props<{ payload?: FetchWeightChartTableDataModel['request'], forPrint?: boolean }>());

const FETCH_WEIGHT_CHART_TABLE_DATA_SUCCESS = '[progress] fetch weight chart table data successful';
export const FetchWeightChartTableDataSuccess = createAction(FETCH_WEIGHT_CHART_TABLE_DATA_SUCCESS, props<{
  data: WeightChartTableData,
  message: string
}>());

const FETCH_WEIGHT_CHART_TABLE_DATA_FAILURE = '[progress] fetch weight chart table data failure';
export const FetchWeightChartTableDataFailure = createAction(FETCH_WEIGHT_CHART_TABLE_DATA_FAILURE);

/******** FETCH DAILY FOOD CHART DATA ***********/
const FETCH_DAILY_FOOD_CHART_DATA_REQUEST = '[progress] fetch daily food chart data requested';
export const FetchDailyFoodChartDataRequest = createAction(FETCH_DAILY_FOOD_CHART_DATA_REQUEST, props<{ payload?: FetchDailyFoodChartDataModel['request'], forPrint?: boolean  }>());

const FETCH_DAILY_FOOD_CHART_DATA_SUCCESS = '[progress] fetch daily food chart data successful';
export const FetchDailyFoodChartDataSuccess = createAction(FETCH_DAILY_FOOD_CHART_DATA_SUCCESS, props<{
  data: GroupedBarChartModel,
  message: string
}>());

const FETCH_DAILY_FOOD_CHART_DATA_FAILURE = '[progress] fetch daily food chart data failure';
export const FetchDailyFoodChartDataFailure = createAction(FETCH_DAILY_FOOD_CHART_DATA_FAILURE);

/******** FETCH WEEKLY FOOD CHART DATA ***********/
const FETCH_WEEKLY_FOOD_CHART_DATA_REQUEST = '[progress] fetch weekly food chart data requested';
export const FetchWeeklyFoodChartDataRequest = createAction(FETCH_WEEKLY_FOOD_CHART_DATA_REQUEST, props<{ payload?: FetchWeeklyFoodChartDataModel['request'], forPrint?: boolean  }>());

const FETCH_WEEKLY_FOOD_CHART_DATA_SUCCESS = '[progress] fetch weekly food chart data successful';
export const FetchWeeklyFoodChartDataSuccess = createAction(FETCH_WEEKLY_FOOD_CHART_DATA_SUCCESS, props<{
  data: BarChartModel,
  message: string
}>());

const FETCH_WEEKLY_FOOD_CHART_DATA_FAILURE = '[progress] fetch weekly food chart data failure';
export const FetchWeeklyFoodChartDataFailure = createAction(FETCH_WEEKLY_FOOD_CHART_DATA_FAILURE);

/******** FETCH WEEKLY FOOD CHART TABLE DATA ***********/
const FETCH_WEEKLY_FOOD_CHART_TABLE_DATA_REQUEST = '[progress] fetch weekly food chart table data requested';
export const FetchWeeklyFoodChartTableDataRequest = createAction(FETCH_WEEKLY_FOOD_CHART_TABLE_DATA_REQUEST, props<{ payload?: FetchWeeklyFoodChartTableDataModel['request'], forPrint?: boolean  }>());

const FETCH_WEEKLY_FOOD_CHART_TABLE_DATA_SUCCESS = '[progress] fetch weekly food chart table data successful';
export const FetchWeeklyFoodChartTableDataSuccess = createAction(FETCH_WEEKLY_FOOD_CHART_TABLE_DATA_SUCCESS, props<{
  data: WeeklyFoodChartTableData,
  message: string
}>());

const FETCH_WEEKLY_FOOD_CHART_TABLE_DATA_FAILURE = '[progress] fetch weekly food chart table data failure';
export const FetchWeeklyFoodChartTableDataFailure = createAction(FETCH_WEEKLY_FOOD_CHART_TABLE_DATA_FAILURE);

/******** FETCH BMI CHART DATA ***********/
const FETCH_BMI_CHART_DATA_REQUEST = '[progress] fetch bmi chart data requested';
export const FetchBmiChartDataRequest = createAction(FETCH_BMI_CHART_DATA_REQUEST, props<{ payload?: FetchBmiChartDataModel['request'], forPrint?: boolean }>());

const FETCH_BMI_CHART_DATA_SUCCESS = '[progress] fetch bmi chart data successful';
export const FetchBmiChartDataSuccess = createAction(FETCH_BMI_CHART_DATA_SUCCESS, props<{
  data: LineChartDataModel,
  message: string
}>());

const FETCH_BMI_CHART_DATA_FAILURE = '[progress] fetch bmi chart data failure';
export const FetchBmiChartDataFailure = createAction(FETCH_BMI_CHART_DATA_FAILURE);

/******** FETCH BMI CHART TABLE DATA ***********/
const FETCH_BMI_CHART_TABLE_DATA_REQUEST = '[progress] fetch bmi chart table data requested';
export const FetchBmiChartTableDataRequest = createAction(FETCH_BMI_CHART_TABLE_DATA_REQUEST, props<{ payload?: FetchBmiChartTableDataModel['request'], forPrint?: boolean }>());

const FETCH_BMI_CHART_TABLE_DATA_SUCCESS = '[progress] fetch bmi chart table data successful';
export const FetchBmiChartTableDataSuccess = createAction(FETCH_BMI_CHART_TABLE_DATA_SUCCESS, props<{
  data: BmiChartTableData,
  message: string
}>());

const FETCH_BMI_CHART_TABLE_DATA_FAILURE = '[progress] fetch bmi chart table data failure';
export const FetchBmiChartTableDataFailure = createAction(FETCH_BMI_CHART_TABLE_DATA_FAILURE);

/******** FETCH BMI GOAL FILTER DATA ***********/
const FETCH_BMI_GOAL_FILTER_DATA_REQUEST = '[progress] fetch bmi goal filter data requested';
export const FetchBmiGoalFilterDataRequest = createAction(FETCH_BMI_GOAL_FILTER_DATA_REQUEST);

const FETCH_BMI_GOAL_FILTER_DATA_SUCCESS = '[progress] fetch bmi goal filter data successful';
export const FetchBmiGoalFilterDataSuccess = createAction(FETCH_BMI_GOAL_FILTER_DATA_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_BMI_GOAL_FILTER_DATA_FAILURE = '[progress] fetch bmi goal filter data failure';
export const FetchBmiGoalFilterDataFailure = createAction(FETCH_BMI_GOAL_FILTER_DATA_FAILURE);

/******** FETCH ADULT BMI GOAL FILTER DATA ***********/
const FETCH_ADULT_BMI_GOAL_FILTER_DATA_REQUEST = '[progress] fetch adult bmi goal filter data requested';
export const FetchAdultBmiGoalFilterDataRequest = createAction(FETCH_ADULT_BMI_GOAL_FILTER_DATA_REQUEST);

const FETCH_ADULT_BMI_GOAL_FILTER_DATA_SUCCESS = '[progress] fetch adult bmi goal filter data successful';
export const FetchAdultBmiGoalFilterDataSuccess = createAction(FETCH_ADULT_BMI_GOAL_FILTER_DATA_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_ADULT_BMI_GOAL_FILTER_DATA_FAILURE = '[progress] fetch adult bmi goal filter data failure';
export const FetchAdultBmiGoalFilterDataFailure = createAction(FETCH_ADULT_BMI_GOAL_FILTER_DATA_FAILURE);



/******** FETCH DAILY_PA_CHART DATA ***********/
const FETCH_DAILY_PA_CHART_DATA_REQUEST = '[progress] fetch daily pa chart' +
                                          ' data requested';
export const FetchDailyPAChartDataRequest = createAction(FETCH_DAILY_PA_CHART_DATA_REQUEST, props<{ payload?: FetchDailyPAChartDataModel['request'], forPrint?: boolean  }>());

const FETCH_DAILY_PA_CHART_DATA_SUCCESS = '[progress] fetch daily pa chart' +
                                          ' data successful';
export const FetchDailyPAChartDataSuccess = createAction(FETCH_DAILY_PA_CHART_DATA_SUCCESS, props<{
  data: GroupedBarChartModel,
  message: string
}>());

const FETCH_DAILY_PA_CHART_DATA_FAILURE = '[progress] fetch daily pa chart data failure';
export const FetchDailyPAChartDataFailure = createAction(FETCH_DAILY_PA_CHART_DATA_FAILURE);

/******** FETCH WEEKLY PA DATA ***********/
const FETCH_WEEKLY_PA_CHART_DATA_REQUEST = '[progress] fetch weekly pa chart' +
                                           ' data requested';
export const FetchWeeklyPAChartDataRequest = createAction(FETCH_WEEKLY_PA_CHART_DATA_REQUEST, props<{ payload?: FetchWeeklyPADataModel['request'], forPrint?: boolean  }>());

const FETCH_WEEKLY_PA_CHART_DATA_SUCCESS = '[progress] fetch weekly pa chart' +
                                           ' data successful';
export const FetchWeeklyPAChartDataSuccess = createAction(FETCH_WEEKLY_PA_CHART_DATA_SUCCESS, props<{
  data: BarChartModel,
  message: string
}>());

const FETCH_WEEKLY_PA_CHART_DATA_FAILURE = '[progress] fetch weekly pa' +
                                           ' chart data failure';
export const FetchWeeklyPAChartDataFailure = createAction(FETCH_WEEKLY_PA_CHART_DATA_FAILURE);

/******** FETCH PA TABLE DATA ***********/
const FETCH_PA_TABLE_DATA_REQUEST = '[progress] fetch pa table data requested';
export const FetchPATableDataRequest = createAction(FETCH_PA_TABLE_DATA_REQUEST, props<{ payload?: FetchPATableDataModel['request'], forPrint?: boolean  }>());

const FETCH_PA_TABLE_DATA_SUCCESS = '[progress] fetch pa table data successful';
export const FetchPATableDataSuccess = createAction(FETCH_PA_TABLE_DATA_SUCCESS, props<{
  data: PATableData,
  message: string
}>());

const FETCH_PA_TABLE_DATA_FAILURE = '[progress] fetch pa data failure';
export const FetchPATableDataFailure = createAction(FETCH_PA_TABLE_DATA_FAILURE);




/******** FETCH DAILY_ST_CHART DATA ***********/
const FETCH_DAILY_ST_CHART_DATA_REQUEST = '[progress] fetch daily ST chart' +
                                          ' data requested';
export const FetchDailySTChartDataRequest = createAction(FETCH_DAILY_ST_CHART_DATA_REQUEST, props<{ payload?: FetchDailySTChartDataModel['request'], forPrint?: boolean  }>());

const FETCH_DAILY_ST_CHART_DATA_SUCCESS = '[progress] fetch daily ST chart' +
                                          ' data successful';
export const FetchDailySTChartDataSuccess = createAction(FETCH_DAILY_ST_CHART_DATA_SUCCESS, props<{
  data: GroupedBarChartModel,
  message: string
}>());

const FETCH_DAILY_ST_CHART_DATA_FAILURE = '[progress] fetch daily ST chart data failure';
export const FetchDailySTChartDataFailure = createAction(FETCH_DAILY_ST_CHART_DATA_FAILURE);

/******** FETCH WEEKLY ST DATA ***********/
const FETCH_WEEKLY_ST_CHART_DATA_REQUEST = '[progress] fetch weekly ST chart' +
                                           ' data requested';
export const FetchWeeklySTChartDataRequest = createAction(FETCH_WEEKLY_ST_CHART_DATA_REQUEST, props<{ payload?: FetchWeeklySTDataModel['request'], forPrint?: boolean  }>());

const FETCH_WEEKLY_ST_CHART_DATA_SUCCESS = '[progress] fetch weekly ST chart' +
                                           ' data successful';
export const FetchWeeklySTChartDataSuccess = createAction(FETCH_WEEKLY_ST_CHART_DATA_SUCCESS, props<{
  data: BarChartModel,
  message: string
}>());

const FETCH_WEEKLY_ST_CHART_DATA_FAILURE = '[progress] fetch weekly ST' +
                                           ' chart data failure';
export const FetchWeeklySTChartDataFailure = createAction(FETCH_WEEKLY_ST_CHART_DATA_FAILURE);

/******** FETCH ST TABLE DATA ***********/
const FETCH_ST_TABLE_DATA_REQUEST = '[progress] fetch ST table data requested';
export const FetchSTTableDataRequest = createAction(FETCH_ST_TABLE_DATA_REQUEST, props<{ payload?: FetchSTTableDataModel['request'], forPrint?: boolean  }>());

const FETCH_ST_TABLE_DATA_SUCCESS = '[progress] fetch ST table data successful';
export const FetchSTTableDataSuccess = createAction(FETCH_ST_TABLE_DATA_SUCCESS, props<{
  data: STTableData,
  message: string
}>());

const FETCH_ST_TABLE_DATA_FAILURE = '[progress] fetch ST data failure';
export const FetchSTTableDataFailure = createAction(FETCH_ST_TABLE_DATA_FAILURE);



/******** FETCH JOURNAL CHART DATA ***********/
const FETCH_JOURNAL_CHART_DATA_REQUEST = '[progress] fetch journal chart data requested';
export const FetchJournalChartDataRequest = createAction(FETCH_JOURNAL_CHART_DATA_REQUEST, props<{ payload?: FetchJournalChartDataModel['request'], forPrint?: boolean }>());

const FETCH_JOURNAL_CHART_DATA_SUCCESS = '[progress] fetch journal chart data successful';
export const FetchJournalChartDataSuccess = createAction(FETCH_JOURNAL_CHART_DATA_SUCCESS, props<{
  data: JournalChartDataModel,
  message: string
}>());

const FETCH_JOURNAL_CHART_DATA_FAILURE = '[progress] fetch journal chart data failure';
export const FetchJournalChartDataFailure = createAction(FETCH_JOURNAL_CHART_DATA_FAILURE);

/******** FETCH JOURNAL CHART TABLE DATA ***********/
const FETCH_JOURNAL_CHART_TABLE_DATA_REQUEST = '[progress] fetch journal chart table data requested';
export const FetchJournalChartTableDataRequest = createAction(FETCH_JOURNAL_CHART_TABLE_DATA_REQUEST, props<{ payload?: FetchJournalChartTableDataModel['request'], forPrint?: boolean }>());

const FETCH_JOURNAL_CHART_TABLE_DATA_SUCCESS = '[progress] fetch journal chart table data successful';
export const FetchJournalChartTableDataSuccess = createAction(FETCH_JOURNAL_CHART_TABLE_DATA_SUCCESS, props<{
  data: JournalChartTableData,
  message: string
}>());

const FETCH_JOURNAL_CHART_TABLE_DATA_FAILURE = '[progress] fetch journal chart table data failure';
export const FetchJournalChartTableDataFailure = createAction(FETCH_JOURNAL_CHART_TABLE_DATA_FAILURE);
